<template>
  <div class="fling-order" v-if="currentSku">
    <navbar left-text show-home title="充值"/>
    <div class="fling-order-wrapper">
      <div class="sku-intro" >
        <div class="sku-img">
          <img v-lazy="currentSku.pic_url" alt />
        </div>
        <div class="sku-name">{{currentSku.name}}</div>
      </div>
      <div class="form">
        <div class="form-options" v-for="(option, index) in formList" :key="index">
          <div class="label">请输入要充值的{{option.title}}</div>
          <input
            type="text"
            :name="option.field"
            :placeholder="option.placeholder"
            :ref="option.field"
            maxlength="64"/>
        </div>
      </div>
      <div class="sku-options">
        <div class="title">规格</div>
        <radio-group v-model="checkedSkuid">
          <radio
            class="option"
            v-for="(sku, index) in skuList"
            :key="index"
            label-position="right"
            icon-size="0.4rem"
            :name="sku.sku_id"
            checked-color="#2ECC71"
          >
            <div class="option-intro">
              <div class="time">
                <div class="attr">
                  <span class="month" v-for="(attr, index) in sku.attr_list" :key="index">{{attr.attr_value.value}}</span>
                </div>
                <div class="market-price">
                  市场价: {{sku.market_price}}元
                </div>
              </div>
              <div class="price-rebate">
                <span class="price" v-show="skuPrice(sku)">会员价: ¥{{skuPrice(sku)}}元</span>
                <span class="rebate" v-show="rebate(sku) * 1 > 0">返 {{rebate(sku)}} 元</span>
              </div>
            </div>
          </radio>
        </radio-group>
      </div>
    </div>
    <div class="member-tips" v-if="userInfo && userInfo.top_member">
      <p>
      您目前还不是{{userInfo.top_member.name}}，无法享受会员专属优惠价格，以上商品购买均为市场价。即刻享受会员优惠价请点击“去开通”
      </p>
    </div>
    <open-member-tips v-if="userInfo && userInfo.top_member" :discounts="discount" />
    <div class="functional-btn">
      <button :disabled="flag" @click="submitOrder">购买</button>
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/NavBar'
import { RadioGroup, Radio } from 'vant'
import OpenMemberTips from '../../components/OpenMemberTips'
import api from '../../utils/api'
import { mapState } from 'vuex'
import Big from 'big.js'
import { wechat } from '../../utils/wechat'
const init = new Big(0)
export default {
  name: 'flingOrder',
  components: {
    Navbar,
    RadioGroup,
    Radio,
    OpenMemberTips
  },
  data () {
    return {
      checkedSkuid: '',
      skuDetails: {},
      formList: [],
      skuList: [],
      flag: false,
      filling: {}
    }
  },
  computed: {
    ...mapState('store', [
      'userInfo'
    ]),
    skuPrice (sku) {
      return (sku) => {
        return (sku.activity && sku.activity.discount) || (sku.equity && sku.equity.discount)
      }
    },
    rebate (sku) {
      return (sku) => {
        return (sku.activity && sku.activity.rebate) || (sku.equity && sku.equity.rebate) || 0
      }
    },
    currentSku () {
      return this.skuList.find(v => v.sku_id === this.checkedSkuid)
    },
    currentSkuPrice () {
      return (this.currentSku.activity && this.currentSku.activity.discount) || (this.currentSku.equity && this.currentSku.equity.discount)
    },
    discount () {
      return init.plus(this.currentSku.market_price).minus(this.currentSkuPrice).toFixed(2)
    }
  },
  created () {
    this.$toast.loading({
      duration: 300000,
      message: '正在加载...',
      forbidClick: true
    })
    const { goodsid, skuid, paltform } = this.$route.query
    this.goodsid = goodsid
    this.paltform = paltform
    this.checkedSkuid = skuid * 1
    this.getSpuDetails(goodsid, skuid).then(() => {
      setTimeout(() => {
        wechat({
          fullPath: this.$route.fullPath,
          name: this.$route.name,
          title: this.currentSku.name,
          desc: `黑卡PLUS会员专享价: ¥${this.currentSkuPrice || this.currentSku.market_price}`,
          imgUrl: this.currentSku.pic_url
        })
      }, 500)
    })
    this.getFormList(skuid)
  },
  methods: {

    /**
     * 提交订单
    */
    async submitOrder () {
      const status = await this.examineForm()
      if (status.includes(false)) {
        return false
      }
      if (this.flag) {
        return false
      }
      this.flag = true
      this.$toast.loading({
        message: '正在为您下单...',
        duration: 300000,
        forbidClick: true
      })
      const res = await this.$axios.post('api/recharge/order', { id: this.checkedSkuid, filling: this.filling })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.pay(data).then(() => {
            this.flag = false
          })
        } else if (code === -1) {

        } else {
          this.$toast(msg)
        }
      }
    },
    async pay (id) {
      this.$toast.loading({
        message: '下单成功,正在为您拉起支付',
        duration: 300000,
        forbidClick: true
      })
      const res = await this.$axios.post('api/pay/recharge', { id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          location.href = data.redirect
        } else {
          this.$toast(msg)
        }
      }
    },
    async examineForm () {
      return this.formList.map(form => {
        const val = this.$refs[form.field][0].value
        this.filling[form.field] = val
        if (val === '') {
          this.$toast(`${form.title}不能为空`)
          return false
        }
        if (form.type === 'mobile') {
          if (!/^1[3,4,5,6,7,8,9]\d{9}$/i.test(val)) {
            this.$toast(`请输入正确的${form.title}`)
            return false
          }
        }
        if (form.type === 'mail') {
          if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)) {
            this.$toast('请输入正确的邮箱的地址')
            return false
          }
        }
      })
    },
    /**
     *获取表单列表
    */
    async getFormList (skuid) {
      const res = await this.$axios.get(`api/recharge/info/${skuid}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.formList = data
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取商品详情
     */
    async getSpuDetails (goodsid, skuid) {
      const data = await api.getSpuDetails({ goodsid, skuid })
      if (data) {
        this.skuList = data.sku_list.sort((x, y) => {
          return x.market_price - y.market_price
        })
      }
    }

  }
}
</script>

<style lang="less" scoped>
.fling-order {
}
.fling-order-wrapper {
  padding: 0 0.2rem;
  background-color: #fff;
  .sku-intro {
    height: 1rem;
    display: flex;
    align-items: center;
    border-bottom: 0.5px solid #979797;
    .sku-img {
      width: 1.27rem;
      height: 0.61rem;
    }
    .sku-name {
      width: 5.2rem;
      .ellipsis2;
      padding-left: 0.3rem;
      font-size: @fz32;
      color: @base;
      font-weight: 700;
    }
  }
  .form {
    font-size: @fz24;
    color: @base;
    .form-options {
      .label {
        padding: 0.27rem 0;
      }
      input {
        width: 6.85rem;
        height: 1.02rem;
        margin: 0 auto;
        border: 0.5px solid #b5b5b5;
        font-size: 0.44rem;
        padding-left: 0.25rem;
      }
    }
  }
  .sku-options {
    font-size: @fz24;
    color: @base;
    .title {
      padding-top: 0.33rem;
    }
    .option {
      width: 100%;
      padding: 0.2rem 0;
      border-bottom: 0.5px solid #e2e2e2;
    }
    .option-intro {
      width: 6rem;
      padding-left: 0.24rem;
      .flex-between;
      .time {
        .flex-column-between;
        .attr {
          width: 3.2rem;
          .ellipsis;
          font-weight: 700;
          font-size: @fz28;
        }
        .market-price {
          font-size: @fz22;
          color: @c80;
        }
      }
      .price-rebate {
        .flex-column;
        align-items: flex-end;
        color: #ff5c5c;
        .price {
          font-weight: 700;
          font-size: @fz28;
        }
        .rebate {
          font-size: @fz22;
        }
      }
    }
  }
  .sku-type {
    font-size: @fz24;
    color: @base;
    .title {
      padding: 0.28rem 0 0.34rem;
    }
    .type {
      padding-bottom: 0.57rem;
    }
  }
}
.member-tips {
  padding: 0.3rem;
  color: @base;
  font-size: @fz28;
  font-weight: 700;
}
.functional-btn {
  margin-top: 0.45rem;
  text-align: center;
  button {
    width: 7.1rem;
    height: 0.88rem;
    color: #fff;
    font-size: @fz32;
    background-color: #27ae60;
    border-radius: 30px;
  }
}
</style>
